import {
  BaseEdge,
  EdgeProps,
  getStraightPath,
  useReactFlow,
} from "@xyflow/react";

function ImageItem(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY, source, target } = props;
  const { getNode } = useReactFlow();

  // Get source and target node data
  const sourceNode = getNode(source);
  const targetNode = getNode(target);

  // Calculate the center of the source and target nodes using their width/height if available
  const sourceWidth = sourceNode?.width ?? 0;
  const sourceHeight = sourceNode?.height ?? 0;
  const targetWidth = targetNode?.width ?? 0;
  const targetHeight = targetNode?.height ?? 0;

  const centerSourceX = sourceX + sourceWidth / 2;
  const centerSourceY = sourceY + sourceHeight / 2;
  const centerTargetX = targetX + targetWidth / 2;
  const centerTargetY = targetY + targetHeight / 2;

  const [edgePath] = getStraightPath({
    sourceX: centerSourceX,
    sourceY: centerSourceY,
    targetX: centerTargetX,
    targetY: centerTargetY,
  });

  return <BaseEdge path={edgePath} {...props} />;
}

export default ImageItem;
